import { Link } from 'react-router-dom';
import { InboxIcon } from 'lucide-react';
import { EmptyState } from '../ui/EmptyState';
import { useAdmin } from '../AdminContext';
import { listBox } from '../ui/styles';
import { received } from './inboxRules';
import type { Inbox } from '../../core/types/adminRequests';

/** Huidadviezen uit de quiz, naast de stand van de nieuwsbrief. */
export function InboxLeads({
  leads,
  newsletter
}: Pick<Inbox, 'leads' | 'newsletter'>) {
  const {
    index
  } = useAdmin();
  return <div className="grid gap-6 lg:grid-cols-3" data-id="element-1683" data-mp="22ggtnx41u6oe">
      {leads.length === 0 ? <EmptyState icon={InboxIcon} title="Nog geen huidadviezen" className="lg:col-span-2" data-id="element-1684" data-mp="22eceuk4m3n9c" /> : <ul className={`${listBox} lg:col-span-2`} data-id="element-1685" data-mp="2b90n8j5hhl2d">
          {leads.map(l => <li key={l.id} className="px-5 py-4" data-id="element-1686" data-mp="2bav85xgr9d6g">
              <p className="text-[14px] text-ink" data-id="element-1687" data-mp="1eq3185hjy5ta">
                {l.lead.email} <span className="text-muted" data-id="element-1688" data-mp="1ishjanded1ji">· {received(l.receivedAt)}</span>
              </p>
              <p className="mt-0.5 text-[13px] text-muted" data-id="element-1689" data-mp="3d49wv6oavz8b">
                Advies: <span className="text-ink" data-id="element-1690" data-mp="3d3gm7um80pkw">{index.routineById(l.lead.routineId)?.name ?? l.lead.routineId}</span> ·{' '}
                {l.lead.answers.map(a => a.answer).join(' · ')}
              </p>
            </li>)}
        </ul>}
      {/* De teller zelf staat bij Mail & nieuwsbrief › Abonnees; hier alleen de verwijzing. */}
      <p className="text-[13px] text-muted" data-id="element-1691" data-mp="2tgshkq8kr29r">
        {newsletter.lastWeek} nieuwe nieuwsbrieflezers deze week.{' '}
        <Link to="/be/mail?tab=abonnees" className="text-ink underline underline-offset-2" data-id="element-1692" data-mp="2pdmc3ktadf4c">
          Bekijk abonnees
        </Link>
      </p>
    </div>;
}